import './app';
import type { DoBootstrap } from '@angular/core';
import { ErrorHandler, inject, NgModule, provideZonelessChangeDetection } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { UpgradeModule } from '@angular/upgrade/static';
import { OverlayModule } from '@angular/cdk/overlay';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { ANGULAR_JS_SERVICES } from './service/migration-helpers/angularjs.injection';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { HTTP_INTERCEPTOR_PROVIDERS } from './interceptor';
import { GlobalAngularErrorHandler } from './service/global-angular-error-handler';
import { registerLtIcons } from './components/core/lt-icon/lt-icon.library';
import { installImageProtection } from './utils/image-protection';
import { installScreenshotBlur } from './utils/screenshot-blur';
import { FeatureFlagService } from './service/feature-flag.service';

const imports = [BrowserModule, UpgradeModule, OverlayModule];

@NgModule({
  imports,
  providers: [
    ...ANGULAR_JS_SERVICES,
    ...HTTP_INTERCEPTOR_PROVIDERS,
    provideZonelessChangeDetection(),
    provideHttpClient(withInterceptorsFromDi()),
    { provide: ErrorHandler, useClass: GlobalAngularErrorHandler }
  ]
})
export class AppModule implements DoBootstrap {
  private readonly featureFlagService = inject(FeatureFlagService);

  constructor(
    public upgrade: UpgradeModule,
    faIconLibrary: FaIconLibrary
  ) {
    registerLtIcons(faIconLibrary);
  }

  ngDoBootstrap() {
    // MLC-13360: read before AngularJS bootstraps — its own bootstrap already stamps
    // mlt.last.access before InitService.init() gets a chance to. Captured earlier still, in
    // index.gsp, before the app bundle even loads. See InitService.init() for where this goes.
    const capturedLastAccessTime = (window as any).mltCapturedLastAccessTime;
    installImageProtection(document);
    if (this.featureFlagService.isEnabled('SCREENSHOT_BLUR')) {
      installScreenshotBlur(window);
    }
    this.upgrade.bootstrap(document.body, ['mlt.mobile']);
    this.upgrade.$injector.get('InitService').init(capturedLastAccessTime);
  }
}
